import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.userDetailPage || initialState;

export const selectUserDetailPage = createSelector(
  [selectSlice],
  state => state,
);
